// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cfdba736","453":"e750ddba","732":"4acc9326"}[chunkId] + ".chunk.js";
};